<template>
  <div class="p-config-management-access">
    <div class="p-config-management-access__header l-block__header">
      <div class="p-config-management-access__title">
        <TitleSub level="h4">各サイトを操作できるユーザーの管理</TitleSub>
        <p class="l-mt-1">
          サイトごとに、サイトの閲覧・編集権限をユーザーに渡すことができます。<br />
          サイトのアクセス権を外したい場合は【削除する】ボタンを押下することでアクセス権を削除できます。
        </p>
      </div>
      <Button
        variant="main"
        fsize="f16"
        icon="plus"
        class="l-w-220 l-pr-4"
        :disabled="hasOrganizations"
        @click="openModalAdd"
      >
        アクセス権を追加する
      </Button>
    </div>
    <div class="p-config-management-access__content">
      <ListAccessUser
        :items="projects"
        :isLoading="isLoading"
        @delete="openModalDelete"
      />
    </div>
    <!-- 複数組織に属するユーザーの場合は使用できません -->
    <template v-if="!hasOrganizations">
      <ModalAddAccessUser
        v-if="modal.add.isActive"
        @add="addUser"
        @close="closeModalAdd"
      />
      <ModalDeleteAccessUser
        v-if="modal.delete.isActive"
        :item="modal.delete.item"
        @delete="deleteUser"
        @close="closeModalDelete"
      />
    </template>
  </div>
</template>

<script>
import Button from '@/components/Button';
import ListAccessUser from '@/components/config/ListAccessUser';
import ModalAddAccessUser from '@/components/config/ModalAddAccessUser';
import ModalDeleteAccessUser from '@/components/config/ModalDeleteAccessUser';
import TitleSub from '@/components/TitleSub';

export default {
  components: {
    Button,
    ListAccessUser,
    ModalAddAccessUser,
    ModalDeleteAccessUser,
    TitleSub
  },
  data() {
    return {
      modal: {
        add: {
          isActive: false
        },
        delete: {
          item: null,
          isActive: false
        }
      },
      isLoading: true
    };
  },
  computed: {
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    projects() {
      return this.$store.state.organizations.projects;
    },
    users() {
      return this.$store.state.organizations.users;
    }
  },
  watch: {
    users: {
      handler(value, oldValue) {
        // ユーザー一覧が更新されたらアクセス権一覧も更新する
        // ユーザーがサイト限定ユーザーからアカウント管理ユーザーに変わった時や、ユーザーが削除された時に整合性が取れなくなるため
        this.getProjects();
      }
    }
  },
  created() {
    this.getProjects();
  },
  methods: {
    getProjects() {
      // 追加モーダルを開いた時にユーザー一覧を更新するためここを通るが、モーダルの背後でローディング表示になるのが気になるので、その時はフラグを立てないようにする
      if (!this.modal.add.isActive) {
        this.isLoading = true;
      }
      this.$store.dispatch('organizations/getProjects').finally(() => {
        this.isLoading = false;
      });
    },
    addUser() {
      this.closeModalAdd();
      this.getProjects();
    },
    deleteUser(item) {
      this.closeModalDelete();

      const projects = JSON.parse(JSON.stringify(this.projects));

      for (let i = 0; i < projects.length; i++) {
        const project = projects[i];
        if (project.projectId === item.projectId) {
          const index = project.users.findIndex(
            user => user.userId === item.userId
          );
          project.users.splice(index, 1);
          break;
        }
      }
      this.$store.dispatch('organizations/setProjects', projects);
    },
    openModalAdd() {
      this.modal.add.isActive = true;
    },
    closeModalAdd() {
      this.modal.add.isActive = false;
    },
    openModalDelete(item) {
      this.modal.delete.item = item;
      this.modal.delete.isActive = true;
    },
    closeModalDelete() {
      this.modal.delete.item = null;
      this.modal.delete.isActive = false;
    }
  }
};
</script>
